const state = {
  loggedInUserProfile: undefined,
  usageStatistics: {}
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/users/state.js